import { render, staticRenderFns } from "./CalendarWarningItem.vue?vue&type=template&id=644112b3&scoped=true&"
import script from "./CalendarWarningItem.vue?vue&type=script&lang=js&"
export * from "./CalendarWarningItem.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWarningItem.vue?vue&type=style&index=0&id=644112b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644112b3",
  null
  
)

export default component.exports